export default "__VITE_ASSET__N$EVyOUK__"